var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgQuestionmark = function SvgQuestionmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.736 16.656v-.64c0-.501.096-.965.288-1.392.192-.427.523-.89.992-1.392.352-.373.597-.699.736-.976.15-.288.224-.576.224-.864 0-.363-.139-.645-.416-.848-.267-.203-.64-.304-1.12-.304-.416 0-.827.064-1.232.192a5.58 5.58 0 00-1.152.512V9.216a4.576 4.576 0 011.264-.48c.48-.117.95-.176 1.408-.176.63 0 1.19.096 1.68.288.501.181.89.464 1.168.848.288.373.432.853.432 1.44 0 .352-.064.693-.192 1.024-.117.32-.288.63-.512.928a6.376 6.376 0 01-.832.896c-.523.459-.885.859-1.088 1.2a2.646 2.646 0 00-.368 1.024l-.064.448h-1.216zM12.224 20v-2.224h2.24V20h-2.24z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export default SvgQuestionmark;